import { UppClientOptions } from '../client/interfaces'
import { Portal } from '../interfaces'

export const PORTAL_DOMAINS: Record<Portal, string> = {
  gmx: 'gmx.net',
  gmxat: 'gmx.net',
  gmxch: 'gmx.net',
  gmxcom: 'gmx.com',
  gmxcouk: 'gmx.co.uk',
  gmxes: 'gmx.es',
  gmxfr: 'gmx.fr',
  mailcom: 'mail.com',
  webde: 'web.de',
}

export function getBrandDomain(portal: UppClientOptions['portal']): string {
  return PORTAL_DOMAINS[portal]
}
